import { render } from "./SituacaoVeiculo.vue?vue&type=template&id=e888cb8c"
import script from "./SituacaoVeiculo.vue?vue&type=script&lang=js"
export * from "./SituacaoVeiculo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__